import {
    AuditIcon,
    Home01Icon,
    PencilEdit02Icon,
    FileAddIcon,
    File01Icon,
    DocumentValidationIcon,
    Folder01Icon,
    CheckmarkSquare01Icon,
    CancelSquareIcon,
    Money01Icon,
    UserMultipleIcon,
    UserGroupIcon,
    ShieldUserIcon,
    Key01Icon,
    Delete01Icon,
    ServerStack01Icon,
    RepeatIcon,
    Message01Icon,
} from '@hugeicons/core-free-icons';

// ["admin", "client", "treasurer", "loan_officer", "portfolio_manager", "head_of_credit", "credit_risk_manager", "head_of_risk"]

const navigation = () => {

    let loLinks = [
        {
            name: 'Home',
            href: '/',
            active: "home",
            permission: null,
            icon: Home01Icon,
        },
        {
            name: 'New Loan App',
            href: '/preloan',
            active: "preloan",
            permission: 'loan_applications:create',
            icon: FileAddIcon,
        },
    ]

    let links = [
        {
            name: 'Home',
            href: '/',
            active: "home",
            permission: null,
            icon: Home01Icon,
        },
        {
            name: 'Loan Applications',
            href: '/loans',
            active: "loans",
            permission: 'loans:view',
            icon: File01Icon,
        },
        {
            name: 'Approved Loans',
            href: '/facility-letters',
            active: "facility-letters",
            permission: 'loans:view',
            icon: DocumentValidationIcon,
        },
        {
            name: 'Active Applications',
            href: '/active-loans',
            active: "active-loans",
            permission: 'loans:view',
            icon: Folder01Icon,
        },
        {
            name: 'Completed Applications',
            href: '/completed-loans',
            active: "completed-loans",
            permission: 'loans:view',
            icon: CheckmarkSquare01Icon,
        },
        {
            name: 'Rejected Applications',
            href: '/rejected-loans',
            active: "rejected-loans",
            permission: 'loans:view',
            icon: CancelSquareIcon,
        },
        {
            name: 'Payments',
            href: '/payments',
            active: "payments",
            permission: 'payments:view',
            icon: Money01Icon,
        },
    ]


    let adminLinks = [
        {
            name: 'Home',
            href: '/admin/home',
            active: "home",
            permission: 'admin:access',
            icon: Home01Icon,
        },
        {
            name: 'Staff',
            href: '/admin/staff',
            active: "staff",
            permission: 'admin:manage_staff',
            icon: UserMultipleIcon,
        },
        {
            name: 'Clients',
            href: '/admin/clients',
            active: "clients",
            permission: 'clients:view',
            icon: UserGroupIcon,
        },
        // {
        //     name: 'Businesses',
        //     href: '/admin/businesses',
        //     active: "businesses",
        //     permission: 'clients:view',
        //     icon: Building04Icon,
        // },
        {
            name: 'Payments',
            href: '/admin/payments',
            active: "payments",
            permission: 'payments:view',
            icon: Money01Icon,
        },
        // {
        //     name: 'Npontu Clients',
        //     href: '/admin/npontu-clients',
        //     active: "npontu-clients",
        //     permission: 'payments:view',
        //     icon: UserGroupIcon,
        // },
        {
            name: 'Roles',
            href: '/admin/roles',
            active: "roles",
            permission: 'admin:manage_roles',
            icon: ShieldUserIcon,
        },
        {
            name: 'Permissions',
            href: '/admin/permissions',
            active: "permissions",
            permission: 'admin:manage_permissions',
            icon: Key01Icon,
        },
        {
            name: 'Send SMS',
            href: '/admin/send-sms',
            active: "send-sms",
            permission: 'sms:send',
            icon: Message01Icon,
        },
        {
            name: 'Edit Loan',
            href: '/admin/loan-edit',
            active: "loan-edit",
            permission: 'admin:access',
            icon: PencilEdit02Icon,
        },
        {
            name: 'Transactions',
            href: '/admin/transactions',
            active: "transactions",
            permission: 'admin:access',
            icon: Delete01Icon,
        },
        {
            name: 'Audit Log',
            href: '/admin/audit-log',
            active: "audit-log",
            permission: 'admin:access',
            icon: AuditIcon,
        },
        {
            name: 'Services',
            href: '/admin/services',
            active: "services",
            permission: 'admin:access',
            icon: ServerStack01Icon,
        },
        {
            name: 'Partner APIs',
            href: '/admin/partner-apis',
            active: "partner-apis",
            permission: 'admin:access',
            icon: Key01Icon,
        },
    ]

    const reversalsIcon = RepeatIcon;

    return { loLinks, links, adminLinks, reversalsIcon }
}

export {
    navigation
}
